module.exports = __webpack_public_path__ + "img/download.374c0c75.svg";